import type { LoadPostingStatus, LoadPostingAssignmentMode, LoadPostingAudience } from '@breaker/shared-types';
import type { StatusTone } from '@/lib/status';

const TONE: Record<LoadPostingStatus, StatusTone> = {
  open: 'active',
  claimed: 'info',
  completed: 'success',
  cancelled: 'danger',
};

const LABEL: Record<LoadPostingStatus, string> = {
  open: 'Open',
  claimed: 'Claimed',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export function postingStatusTone(s: LoadPostingStatus): StatusTone {
  return TONE[s];
}

export function postingStatusLabel(s: LoadPostingStatus): string {
  return LABEL[s];
}

export function postingModeLabel(m: LoadPostingAssignmentMode): string {
  return m === 'claimable' ? 'Claimable' : 'Direct assign';
}

export function postingAudienceLabel(a: LoadPostingAudience): string {
  return a === 'marketplace' ? 'Marketplace' : 'Internal';
}
